import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "notificationManager" }
const _hoisted_2 = { class: "notificationTitle" }
const _hoisted_3 = {
  key: 0,
  class: "notificationSubtitle"
}
const _hoisted_4 = { class: "notificationText" }
const _hoisted_5 = ["onClick"]

import router from "@/router";
import axios from "axios";
import { ComputedRef, computed } from "vue";
import { useStore } from "vuex";

// Variables
import HeyButton from "./components/HeyButton.vue";
import NextIcon from "./components/Icons/NextIcon.vue";

type Notification = {
  text: string;
  title: string;
  subtitle?: string;
  id: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// Libraries and Imports
const store = useStore();

// Types
if (store.state.authStatus == 2) {
  // Get friends
  axios.get("/friendships/all").then(({ data }) => {
    store.dispatch("addAllFriendships", data);
  });
}

function keepYOffsetSame(el: Element) {
  const notif = el as HTMLDivElement;
  const notifManager = notif.parentElement as HTMLDivElement;

  // Make sure that if notif that's going away is last, it does same fade out effect as all notifs w/o shifting to right
  notifManager.style.width = `${notifManager.clientWidth}px`;

  // Make sure notif that's going away doesn't jump to top (b/c of absolute positioning)
  notif.style.top = `${notif.offsetTop}px`;
}

function deleteNotif(notificationId: string) {
  store.dispatch("deleteNotif", notificationId);
}

const notifications: ComputedRef<Notification[]> = computed(
  () => store.state.notifications,
);

// Update
async function logout() {
  try {
    await axios.delete("/sessions/delete");
  } catch {
    console.log(
      "Couldn't Delete Your Session. You May Have To Clear Your Session Cookie Manually.",
    );
  }

  store.dispatch("logout");
  router.push("/");
  router.go(0);
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_router_view, {
      key: _unref(router).currentRoute.value.fullPath
    })),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, {
        name: "notif",
        onBeforeLeave: keepYOffsetSame
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (notifcation) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "notification",
              key: notifcation.id
            }, [
              _createElementVNode("p", _hoisted_2, _toDisplayString(notifcation.title), 1),
              (notifcation.subtitle)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(notifcation.subtitle), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_4, _toDisplayString(notifcation.text), 1),
              _createElementVNode("button", {
                class: "notificationButton",
                onClick: ($event: any) => (deleteNotif(notifcation.id))
              }, " Close ", 8, _hoisted_5)
            ]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})